import React, { useRef, KeyboardEvent, ClipboardEvent } from "react";

// OTP Input component defined locally for this page
const OtpInput: React.FC<{
  otp: string[];
  onChange: (otp: string[]) => void;
}> = ({ otp, onChange }) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (element: HTMLInputElement, index: number) => {
    const value = element.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    onChange(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").replace(/[^0-9]/g, "");
    if (paste.length === 6) {
      const newOtp = paste.split("");
      onChange(newOtp);
      inputRefs.current[5]?.focus();
    }
  };

  return (
    <div
      className="flex justify-center space-x-2 sm:space-x-4"
      onPaste={handlePaste}
    >
      {otp.map((data, index) => (
        <input
          key={index}
          type="tel"
          maxLength={1}
          className="w-12 h-12 sm:w-16 sm:h-16 text-center text-3xl font-semibold border-2 border-gray-200 bg-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          value={data}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onFocus={(e) => e.target.select()}
          ref={(el) => {
            inputRefs.current[index] = el;
          }}
          aria-label={`Digit ${index + 1} of verification code`}
        />
      ))}
    </div>
  );
};

export default OtpInput;
